import React from 'react';
import { LibraryAddOutlined } from '@mui/icons-material';
import { Container, ContainerPropsSchema } from './Container';
import ContainerSidebarPanel from './ContainerSidebarPanel';
export default {
    label: 'Container',
    icon: React.createElement(LibraryAddOutlined, null),
    type: 'Container',
    defaultData: {
        style: {
            borderRadius: 0,
            padding: { top: 16, bottom: 16, left: 24, right: 24 }
        },
    },
    SidebarPanel: ContainerSidebarPanel,
    Component: Container,
    schema: ContainerPropsSchema,
};
//# sourceMappingURL=index.js.map